// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"ModalHeaderWithButton_buttonContainer__1SgVk"};